import React from 'react';

const ThemedProfileGrid = ({ className, children, style }) => {
  return (
    <div 
      className={`
        rounded-lg
        shadow-md
        bg-white
        dark:bg-gray-800
        transition-colors
        duration-200
        ${className || ''}
      `}
      style={{
        ...style,
        padding: '2rem 2.5rem',
        boxShadow: 'var(--shadow-color) 0px 4px 8px 0px, var(--shadow-color) 0px 3px 3px 0px',
        backgroundColor: 'var(--card-background)',
        color: 'var(--text-primary)'
      }}
    >
      {children}
    </div>
  );
};

export default ThemedProfileGrid;